import { type ModalProps, Modal as MuiModal } from '@mui/material'
import { type DataTestIdAttribute, type HTMLAttributesWithoutStyling } from '../../types'

export type ModalBaseProps = Pick<
  ModalProps,
  | 'children'
  | 'open'
  | 'onClose'
  | 'disablePortal'

  /**
   * When turned on it means you are now responsible for ensuring focus management for accessibility
   */
  | 'disableAutoFocus'
  | 'disableRestoreFocus'
  | 'keepMounted'
> & {
  isFullscreen?: boolean
} & HTMLAttributesWithoutStyling<HTMLDivElement> &
  DataTestIdAttribute

export const Modal = ({ children, isFullscreen, ...props }: ModalBaseProps) => (
  <MuiModal {...props} className={`${isFullscreen ? 'DhlModal-fullscreen' : ''} DhlModal-container`}>
    {children}
  </MuiModal>
)
